var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('CustomerList')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }